export default {"src":"/_next/static/media/check-1.4acd1fea.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};